import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { getWeekNumber } from "../../../../utils/Common";
import ListaActividadesGuardadas from './ListaActividadesGuardadas';

const VerActividaesV2 = (p) => {
    const aw = getWeekNumber();
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const [forms, setforms] = useState({ valvulas: [], ranchos: [], labores: [], areas: [], semanas: [] });
    const formsNames = ['labores', 'valvulas', 'ranchos', 'areas'];
    const [paginas, setpaginas] = useState([1, 2, 3, 4, 5]);
    const [paginador, setpaginador] = useState({
        page: 1, per_page: 18, total: 0, pages: 1, labor: 0, valvula: 0, rancho: 0, area: 0, semana: `2417`
        //page: 1, per_page: 18, total: 0, pages: 1, labor: 0, valvula: 0, rancho: 0, area: 0, semana: `${aw[0] - 2000}${aw[1]}`
    });/*`${aw[0] - 2000}${aw[1]}`*/

    const [actividades, setactividades] = useState([]);
    useEffect(() => {
        getForms();
        getActividades();
    }, []);

    const getForms = async () => {
        let res = await Post('nomina_externa/labores/formularios', {});
        if (!res.estatus) {
            showDialog('Error', 'Error al cargar los formularios', 'error');
            return
        }
        setforms(res.data);
    }

    const changeFormVal = (event) => {
        let { name, value } = event.target;
        let pag = { ...paginador };
        pag[name] = value;
        pag.page = 1;
        getActividades(pag);
    }

    const getActividades = async (pag = { ...paginador }) => {
        setloader(true);
        let res = await Post('nomina_externa/get_actividades', pag);
        setloader(false);
        if (!res.estatus) {
            showDialog('Error', res.msj, 'error');
            return
        }
        setactividades(res.data);

        pag.total = res.total;
        pag.pages = res.pages;
        pag.per_page = res.per_page;
        setpaginador(pag);
        let pags = [];
        for (let i = 0; i < pag.pages; i++) pags.push(i + 1);
        setpaginas(pags);
        setTimeout(() => {
            let elemento = document.getElementById('contenedor_top');
            if (elemento) elemento.scrollIntoView({ behavior: "smooth" });
        }, 200);
    }

    const showDialog = (title = "", body = "", tipo = "error",) => {
        setdialog({
            show: true,
            tipo: tipo,
            title: title,
            body: body,
            size: 'm',
            funct: () => { setdialog({ show: false }) }
        });
    }

    const changePage = (atras) => {
        let pag = { ...paginador };
        if (atras) pag.page--
        else pag.page++;
        getActividades(pag);
    }
    const jumpPage = (event) => {
        let pag = { ...paginador };
        pag.page = parseInt(event.target.value);
        getActividades(pag);
    }

    //Registra avances de actividad desde el alguno de los modulos hijos para registrar avances
    const registrar = async (data) => {
        console.log(`data en ver actividades`, data);
        setloader(true);
        let resp = await Post("/nomina_externa/registrar_avance", data);
        setloader(false);
        if (!resp.estatus) showDialog('Error', resp.msj, 'error');
        else getActividades();
        return resp.estatus;
    }

    const editar_metas = async (data) => {
        console.log(`data en ver actividades`, data);
        let resp = await Post("/nomina_externa/editar_metas", data);
        if (!resp.estatus) showDialog('Error', resp.msj, 'error');
        else getActividades();
        return resp.estatus;
    }

    return (

        <div className='w-100 m-0 p-0 ps-2 pe-2 text-center'>
            <div className='w-100 h-0 p-0 m-0' id='contenedor_top'></div>
            <div className='row justify-content-evenly w-100 m-0 p-0 bg-white4 blur-l border p-1 round-m shadow-sm' style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <div className='bw-200 p-0 m-1 contenedor'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <label className='text-bold text-s w-100 m-0 p-0'>
                            <span className='text-xs'>Página:</span>
                            ({paginador.page} / {paginador.pages})
                            <span className='ms-2 text-xs'>Registros:</span>
                            {paginador.total_regs}
                        </label>
                        <br className='m-0 p-0' />

                        <button type="button" className="btn btn-sm btn-dark m-0 w-30 shadow-sm text-white round-left-xl"
                            disabled={paginador.page == 1}
                            onClick={() => { changePage(true) }}>❮</button>
                        <select className='form-control form-control-sm text-center m-0 w-40' value={paginador.page} onChange={jumpPage}>
                            {
                                (paginas ?? []).map((pag, i) => {
                                    return (
                                        <option value={pag} key={i + "pagina" + pag} className='ps-3 pe-3'>{pag}</option>
                                    )
                                })
                            }
                        </select>
                        <button type="button" className="btn btn-sm btn-dark m-0 w-30 shadow-sm text-white round-right-xl"
                            disabled={paginador.page >= paginador.pages}
                            onClick={() => { changePage(false) }}>❯</button>
                    </div>

                </div>
                {p.historial && <div className='form-group form-group-sm m-1 p-0 bw-150' >
                    <label className='text-bold text-xs w-100 text-start p-0'>FILTRADO POR SEMANA</label>
                    <select className='form-control form-control-sm shadow-sm border'
                        name={'semana'} value={paginador.semana} onChange={changeFormVal}>
                        <option value={0} >Seleccione una semana</option>
                        {
                            forms.semanas.map((val, i) => <option value={val} key={" " + i}>{val}</option>)
                        }

                    </select>
                </div>}
                {
                    ['labor', 'valvula', 'rancho', 'area'].map((item, index) =>
                        <div className='form-group form-group-sm m-1 p-0 bw-150' key={"menu " + index}>
                            <label className='text-bold text-xs w-100 text-start p-0'>FILTRADO POR {item.toUpperCase()}</label>
                            <select className='form-control form-control-sm shadow-sm border' name={item} value={paginador[item]} onChange={changeFormVal}>
                                <option value={0} >Seleccione {item}</option>
                                {
                                    forms[formsNames[index]].map((val, i) => <option value={val.id} key={index + " " + i}>{val.value}</option>)
                                }

                            </select>
                        </div>
                    )
                }

            </div>
            <div className='row justify-content-evenly w-100 m-0 p-0 '>
                {!loader && actividades.length == 0 && <div className='col-lg-12 text-xl text-center text-bold text-500 text-lg'>
                    No hay actividades registradas para la semana <span className='text-bold text-red4'>{paginador.semana}</span>
                </div>}
                <div className='bw-1400 round-m p-2 ms-0 me-0  mb-3 mt-3 bg-white shadow'>
                    {actividades.length > 0 && <ListaActividadesGuardadas lista={actividades} registrar={registrar} historial={p.historial} editar={editar_metas} />}
                </div>

            </div>
            <VainillaDialog data={dialog} />
            {loader && <div className='blur-s' style={{ width: '100vw', height: '100vh', position: 'fixed', left: 0, top: 0, zIndex: 5 }}><div className='loader'></div></div>}
        </div>



    )
}

export default VerActividaesV2;